import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';


const Auto_Unit = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);

    useImperativeHandle(ref, () => ({

        Bind() {
            trackPromise(
                fetch(General.ApiRoute() + '/Product/GetAllUnit', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value:  result[i].unit,
                                lable:  result[i].unit,
                            })
                        }
                        setList(tmp)
                    })
            )
        },
    }),        
     [props.value])

    return (
        <rsuite.AutoComplete
        data={List.map((product) => ({
          label: `${product.lable}`,
          value: `${product.value}`,
        }))}
        value={props.value}
        label={props.lable}
        onChange={(event)=>props.onChange(event)}
        // onSelect={(event)=>props.onSelect(event)}
        //  onKeyUp={(event)=>props.onKeyUp(event)}
      />    
    )
});

export default Auto_Unit;